<template>
    <div :class="cardClass">
        <!--        <pre >-->
        <!--             {{news}}-->
        <!--        </pre>-->


        <a :class="cardLinkClass" @click.prevent='newsClicked(news)' href="#">

            <div class="inner">
                <div class="news-card__date ">
                    {{ dateFormatted }}
                </div>
                <div class="news-card__body">
                    <h4 class="news-card__title">
                        {{ news.fpDocumentInfo.newsShortText }}
                    </h4>
                </div>
                <div class="news-card__read-more">
                    Сазнајте више
                </div>
            </div>

        </a>
        <news-single-modal :id="modalId" :title="news.fpDocumentInfo.newsShortText" :iframeUrl="iframeUrl"
            :fullText="fullText"></news-single-modal>
    </div>
</template>

<script>
import moment from 'moment';
import NewsSingleModal from '@/components/NewsSingleModal.vue';


moment.locale('sr-cyrl');
export default {
    name: "NewsCard",
    data() {
        return {
            baseApiUrl: window.env.VUE_APP_API_FP_DEV,
            iframeUrl: '',
            modalId: '',
            fullText: ''
        }
    },
    props: [
        'news'
    ],
    components: {
        NewsSingleModal,
    },
    watch: {
        news: {
            handler(val) {
                if (val) {
                    this.iframeUrl = (this.news && this.news.fpDocumentInfo.newsHtmlUuid) ? this.baseApiUrl + 'prins/GetDocTypeHtml?uuid=' + this.news.fpDocumentInfo.newsHtmlUuid + '&id=' + this.news.fpDocumentInfo.newsId + '&doctype=fpnews' : null;
                    this.modalId = 'news_modal_' + this.news.fpDocumentInfo.newsId;
                    this.fullText = this.news.fpDocumentInfo.newsFullText;
                }
            },
            deep: true
        }
    },
    computed: {
        cardClass() {
            let cssClasses = '';
            if (this.news.fpDocumentInfo.newsBreaking === '1') {
                cssClasses = 'news-card h-100    news-breaking'
            } else {
                cssClasses = 'news-card h-100   '
            }
            return cssClasses
        },
        cardLinkClass() {
            let cssClasses = '';
            if (this.news.fpDocumentInfo.newsBreaking === '1') {
                cssClasses = 'news-card__link    news-breaking__link'
            } else {
                cssClasses = 'news-card__link   '
            }
            return cssClasses
        },
        dateFormatted() {
            let fornated = new Date(this.news.newsPublishedDateTime);

            // fornated.format("D. MMM  ");
            return moment(fornated).format('D. MMM').toLowerCase();
        },
    },
    methods: {
        newsClicked(newsItem) {
            if (newsItem.fpDocumentInfo.newsDirectLink) {
                if (newsItem.fpDocumentInfo.newsDirectLink.includes("NP")) {
                    this.$router.push('/slglrsNP-overview/all');
                } else if (newsItem.fpDocumentInfo.newsDirectLink.includes("MUTG")) {
                    this.$router.push('/slglrsMUTG-overview/all');
                } else if (newsItem.fpDocumentInfo.newsDirectLink.includes("PG2010")) {
                    this.$router.push('/slglrsPG2010-overview/all');
                }
            } else if (newsItem.fpDocumentInfo.newsIncludeInSearchResult != "0") {
                this.$bvModal.show(this.modalId);
            }
        }
    },
    mounted() {
        this.iframeUrl = (this.news && this.news.fpDocumentInfo.newsHtmlUuid) ? this.baseApiUrl + 'prins/GetDocTypeHtml?uuid=' + this.news.fpDocumentInfo.newsHtmlUuid + '&id=' + this.news.fpDocumentInfo.newsId + '&doctype=fpnews' : null;
        this.modalId = 'news_modal_' + this.news.fpDocumentInfo.newsId;
        this.fullText = this.news.fpDocumentInfo.newsFullText;
    }
}
</script>

<style scoped></style>
